import { useTranslation } from "react-i18next";
import { useFieldContext } from "../hooks/surveyResponseFormHooks";
import { CharacterCount } from "@pulse/components/CharacterCount";
import { getFirstErrorMessage } from "@pulse/utils/formErrors";

function CommentSection({ maxCharacters }: { maxCharacters?: number }) {
    const { t } = useTranslation();
    const field = useFieldContext();
    const value = (field.state.value as string | undefined) ?? "";
    const errorMessage = getFirstErrorMessage(field.state.meta.errors);
    const isAtMaxLength = maxCharacters !== undefined && value.length >= maxCharacters;
    const hasErrorStyle = Boolean(errorMessage) || isAtMaxLength;

    return (
        <div className="mb-10 flex flex-col gap-1">
            <div className="flex items-end justify-between gap-4">
                <label className="block mb-2 font-light">
                    {t("surveyResponse.additionalComments")} (
                    <span className="text-on-container/50">
                        {t("common.optional").toLowerCase()}
                    </span>
                    )
                </label>
                {maxCharacters && (
                    <CharacterCount currentLength={value.length} maxLength={maxCharacters} />
                )}
            </div>
            <textarea
                className={`w-full border rounded p-2 text-sm ${
                    hasErrorStyle
                        ? "border-error ring-2 ring-error focus:ring-2 focus:ring-error focus:border-error"
                        : "border-gray-300 focus:ring-2 focus:ring-info focus:border-transparent"
                }`}
                rows={3}
                value={value}
                onChange={(e) => field.handleChange(e.target.value)}
                name={field.name}
                maxLength={maxCharacters}
                onBlur={field.handleBlur}
            />
            {errorMessage && (
                <div className="text-sm text-error">
                    {t(errorMessage, maxCharacters ? { max: maxCharacters } : {})}
                </div>
            )}
            {!errorMessage && isAtMaxLength && (
                <div className="text-sm">{t("common.maxLengthReached")}</div>
            )}
        </div>
    );
}

export default CommentSection;
